import {
  base_colorContentBorderSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontH2, fontSupportMedium } from 'ext-ui/style/typography'
import { css } from 'styled-components'

const fundingAccountVerificationModalStyle = css`
  /* The interactive BaseModal variant sets width only; consumers own padding. */
  &.FundingAccountVerificationModal {
    display: flex;
    width: 100%;
    max-width: 100%;
    flex-direction: column;
    gap: ${spacing(6)};
    padding: ${spacing(10)};
  }

  .FundingAccountVerificationModal-header {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
  }

  .FundingAccountVerificationModal-title {
    ${fontH2};
    margin: 0;
    color: ${text_colorTextPrimary};
  }

  .FundingAccountVerificationModal-copy {
    ${fontSupportMedium};
    margin: 0;
    color: ${text_colorTextSecondary};
  }

  .FundingAccountVerificationModal-form {
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
  }

  .FundingAccountVerificationModal-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${spacing(4)};
  }

  .FundingAccountVerificationModal-fields > * {
    min-width: 0;
  }

  .FundingAccountVerificationModal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${spacing(3)};
    border-top: 1px solid ${base_colorContentBorderSecondary};
    padding-top: ${spacing(5)};
  }

  @media (max-width: 640px) {
    .FundingAccountVerificationModal-fields {
      grid-template-columns: 1fr;
    }

    .FundingAccountVerificationModal-footer {
      align-items: stretch;
      flex-direction: column-reverse;
    }
  }
`

export default fundingAccountVerificationModalStyle
